/**
 * Ediciones — catálogo de campeonatos que cubrimos.
 *
 * El Panel de equipo (src/views/Panel.tsx) lee TODO de aquí. Para cubrir un
 * campeonato nuevo (p. ej. el Europeo Absoluto) NO hay que tocar vistas ni
 * rutas: basta con añadir una entrada a EDICIONES y marcarla `activa`.
 *
 * `id` es el trozo de URL del panel: /panel/<id>  (p. ej. /panel/malaga).
 * Usa un slug corto, en minúsculas y sin acentos.
 */

export interface Edicion {
  /** Slug para la URL del panel (/panel/<id>). Minúsculas, sin acentos. */
  id: string;
  /** Título visible del campeonato. */
  titulo: string;
  /** Sede / estadio. */
  sede: string;
  /** Fecha de inicio en ISO (yyyy-mm-dd). */
  fechaInicio: string;
  /** Fecha de fin en ISO (yyyy-mm-dd). */
  fechaFin: string;
  /**
   * Código del campeonato en rfealive.es. Con él, la herramienta arma la URL
   * `https://rfealive.es/sch/<rfeaCode>` (ver urlDeCampeonato en lib/api.ts).
   * Si aún no se conoce, se deja vacío y el equipo pega la URL a mano en la
   * herramienta de resultados.
   */
  rfeaCode?: string;
  /**
   * `true` = edición activa: la que abre /panel por defecto. Debería haber solo
   * una activa a la vez; si hay varias, se usa la primera de la lista.
   */
  activa: boolean;
}

export const EDICIONES: Edicion[] = [
  {
    id: 'malaga',
    titulo: 'Cto. de España Absoluto 2026',
    sede: 'Estadio de Atletismo Ciudad de Málaga',
    fechaInicio: '2026-07-24',
    fechaFin: '2026-07-26',
    // TODO (Riki): pega aquí el `code` de rfealive.es cuando la competición
    // esté publicada, para que la herramienta la cargue de un clic.
    rfeaCode: '',
    activa: true,
  },
  // Próxima edición (ejemplo, desactivada). Al llegar el Europeo, rellena los
  // datos reales y pon `activa: true` (y `activa: false` en Málaga):
  // {
  //   id: 'europeo',
  //   titulo: 'Cto. de Europa Absoluto 2026',
  //   sede: '—',
  //   fechaInicio: '2026-08-11',
  //   fechaFin: '2026-08-16',
  //   rfeaCode: '',
  //   activa: false,
  // },
];

/** Todas las ediciones, en orden de definición. */
export function listaEdiciones(): Edicion[] {
  return EDICIONES;
}

/** Busca una edición por su slug. `undefined` si no existe. */
export function getEdicion(id: string): Edicion | undefined {
  return EDICIONES.find((e) => e.id === id);
}

/** La edición activa (la primera marcada `activa`); si ninguna lo está, la
 *  primera de la lista. Nunca devuelve undefined mientras EDICIONES no esté
 *  vacío. */
export function edicionActiva(): Edicion {
  return EDICIONES.find((e) => e.activa) ?? EDICIONES[0];
}
